import { initGoogleAnalytics } from './google-analytics-config';
import { initMuiConfig } from './mui-config';

export function init() {
  initMuiConfig();
  initGoogleAnalytics();
}
